export default __webpack_public_path__ + "static/media/create-account.bde52ca7.svg";